export default {
  PageName: 'Cross Border',
  SearchPlaceholder: 'Search for Line / Customer',
  viewBw: 'View cross-border traffic',
  sn: 'Dedicate Line SN',
  lineName: 'Line',
  crossBorderLineBw: 'Cross Border Line Bandwidth(M)',
  customerBw: 'Customer Bandwidth(M)',
  allBw: 'All Bandwidth(M)',
  CrossFlow: 'Cross Flow',
  OrderCustomer: 'Order Customer',
  AllCustomers: 'All Customers',
  StatisticsTime: 'Statistics Time',
  upTraffic: 'Upstream Traffic',
  downTraffic: 'Downstream Traffic',
}